import { createApp } from 'vue'
import App from './App.vue'
import store from './store';
import router from './router'
import './assets/css/master.css'
import './assets/css/app.css'
import './assets/css/m/master.css'

import Armenian from './assets/language/Armenian.json'
import Bengali from './assets/language/Bengali.json'
import Burmese from './assets/language/Burmese.json'
import Chinese from './assets/language/Chinese.json'
import English from './assets/language/English.json'
import Farsi from './assets/language/Farsi.json'
import Gujarati from './assets/language/Gujarati.json'
import Hindi from './assets/language/Hindi.json'
import Indonesian from './assets/language/Indonesian.json'
import Japanese from './assets/language/Japanese.json'
import Khmer from './assets/language/Khmer.json'
import Korean from './assets/language/Korean.json'
import Mongolian from './assets/language/Mongolian.json'
import Russian from './assets/language/Russian.json'
import Spanish from './assets/language/Spanish.json'
import Tagalog from './assets/language/Tagalog.json'
import Telugu from './assets/language/Telugu.json'
import Thai from './assets/language/Thai.json'
import Vietnamese from './assets/language/Vietnamese.json'
import { createI18n } from 'vue-i18n/index'
const languages = createI18n({
    locale: localStorage.getItem('language') || 'English',
    messages: {
        Armenian,
        Bengali,
        Burmese,
        Chinese,
        English,
        Farsi,
        Gujarati,
        Hindi,
        Indonesian,
        Japanese,
        Khmer,
        Korean,
        Mongolian,
        Russian,
        Spanish,
        Tagalog,
        Telugu,
        Thai,
        Vietnamese
    }
});

const app = createApp(App);
app.config.globalProperties.$msalInstance = {};
app.use(store).use(router).use(languages).mount('#app');